export default __webpack_public_path__ + "static/media/login-bg2.892e5ec2.jpg";